export default {
  name: 'd2-throttle',
  functional: true,
  render: function render(createElement, context) {
    // [options.leading=true] (boolean): 指定调用在节流开始前
    // [options.trailing=true] (boolean): 指定调用在节流结束后
    var options = function options() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$leading = _ref.leading,
          leading = _ref$leading === void 0 ? true : _ref$leading,
          _ref$trailing = _ref.trailing,
          trailing = _ref$trailing === void 0 ? true : _ref$trailing;

      return {
        leading: leading,
        trailing: trailing
      }(context.props);
    };

    var wait = context.props.wait;
    var vnodeList = context.slots().default;

    if (vnodeList === undefined) {
      console.warn('<d2-throttle> 组件必须要有子元素');
      return null;
    }

    var vnode = vnodeList[0] || null;

    if (vnode.tag === 'button') {
      var defaultFun = vnode.data.on.click;

      var throttleFun = this._.throttle(defaultFun, wait, options);

      vnode.data.on.click = throttleFun;
    } else if (vnode.componentOptions && vnode.componentOptions.tag === 'el-button') {
      var _defaultFun = vnode.componentOptions.listeners.click;

      var _throttleFun = this._.throttle(_defaultFun, wait, options);

      vnode.componentOptions.listeners.click = _throttleFun;
    } else {
      console.warn('<d2-throttle> 组件内只能出现下面组件的任意一个且唯一 el-button、button');
      return vnode;
    }

    return vnode;
  }
};